import React from 'react'
import { isMobile } from 'react-device-detect'
import {
  DcSwitch,
  PixelDiv,
  PixelFactoryContext,
  PixelFlexBox,
  PixelText,
  Section,
  SectionContent,
  SectionTitle,
} from 'pixel-base'

import { get } from 'utils/api-routes.util'
import { IPixelFactory } from '../../../../../../decl.d'

interface ISubs {
  display_name: string
  feature: string
  feature_description: string
  feature_value: boolean
}

export const Subscriptions = () => {
  const { showLoader, hideLoader } =
    React.useContext<IPixelFactory>(PixelFactoryContext)
  const mainSectionRef = React.useRef(null)
  const [settingMessage, setSettingMessage] = React.useState(false)
  const [subs, setSubs] = React.useState<ISubs[]>([])
  React.useEffect(() => {
    readData()
  }, [])

  const readData = () => {
    showLoader(mainSectionRef)
    get('/tenant/subscriptions').subscribe((res: any) => {
      setSubs(res.response.data)
      hideLoader(mainSectionRef)
    })
  }

  // const updateSub = (subscription: ISubs, isEnable: boolean) => {
  //   updateData(subscription, isEnable)
  // }

  // const updateData = (subscription: ISubs, isEnable: boolean) => {
  //   showLoader(mainSectionRef)
  //   put('/tenant/subscriptions', {
  //     feature_id: subscription.feature,
  //     enable: isEnable ? 1 : 0,
  //   }).subscribe((res: any) => {
  //     if (res.response.data) {
  //       showSuccess(
  //         `${subscription.display_name.toUpperCase()} TURNED ${
  //           isEnable ? 'ON' : 'OFF'
  //         }.`,
  //       )
  //       setSubs(res.response.data)
  //       hideLoader(mainSectionRef)
  //     } else {
  //       showFailure(res.response.error)
  //       hideLoader(mainSectionRef)
  //     }
  //   })
  // }
  const settings = () => {
    setSettingMessage(true)
  }
  return (
    <Section isMobile={isMobile}>
      <PixelFlexBox
        style={{
          minHeight: '10%',
          overflow: 'auto',
          alignItems: 'flex-start',
          height: 'auto',
        }}
        width="100%"
        gap="20px"
      >
        <PixelFlexBox justifyContent="flex-start">
          <SectionTitle>Subscriptions</SectionTitle>
        </PixelFlexBox>
        <PixelFlexBox justifyContent="flex-end">
          <PixelText
            style={{
              fontFamily: 'Courier New',
              padding: '5px',
              wordWrap: 'break-word',
            }}
          >
            {settingMessage &&
              'Contact to the Support Team to update the Settings'}
          </PixelText>
        </PixelFlexBox>
      </PixelFlexBox>
      <SectionContent
        isMobile={isMobile}
        className="subs-content"
        ref={mainSectionRef}
      >
        <PixelDiv>
          {subs.map((sub, i) => {
            return (
              <PixelFlexBox
                key={i}
                flexDirection="row"
                justifyContent="space-between"
                alignItem="center"
                alignContent="center"
                margin="8px 0"
                gap="15px"
              >
                {' '}
                <PixelDiv>
                  <DcSwitch
                    className={'large'}
                    onChange={() => {
                      settings()
                    }}
                    checked={sub.feature_value}
                    label={sub.feature_value ? 'On' : 'Off'}
                  />
                </PixelDiv>
                <PixelFlexBox
                  width="100%"
                  flexDirection="column"
                  justifyContent="flex-start"
                  alignContent="space-around"
                  alignItem="space-around"
                >
                  <PixelText>{sub.display_name}</PixelText>
                  <PixelDiv
                    style={{
                      fontSize: '12px',
                      color: ' #999',
                      fontWeight: '300',
                      maxWidth: '80%',
                    }}
                  >
                    {sub.feature_description}
                  </PixelDiv>
                </PixelFlexBox>
              </PixelFlexBox>
            )
          })}
        </PixelDiv>
      </SectionContent>
    </Section>
  )
}
